export const adminEventMentions = (params: { q: string }) => `q:${params.q}`;
